// Meta Pixel and TikTok Pixel for the marketing website only (never inside the app).
// They load only after the visitor taps "Allow cookies" and stop the moment consent is withdrawn.
// Only standard events are sent, with no form values, emails, quiz answers or free text.
// Pixel IDs are public identifiers, so a default is safe in code; env vars can override them.
const META_ID = process.env.REACT_APP_META_PIXEL_ID || '949340521246023';
const TIKTOK_ID = process.env.REACT_APP_TIKTOK_PIXEL_ID || 'DB8J32RC77U1HDKKTQT0';
const KEY = 'rc_analytics_consent';

let metaLoaded = false;
let tiktokLoaded = false;

// Condition portals stay pixel-free: a visit there would reveal a specific health condition.
const allowedPage = () => !window.location.pathname.startsWith('/portals/');
const granted = () => { if (!allowedPage()) return false; try { return localStorage.getItem(KEY) === 'granted'; } catch { return false; } };

function loadMeta() {
  if (metaLoaded || !META_ID) return;
  metaLoaded = true;
  /* eslint-disable */
  !function (f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq('init', META_ID);
  window.fbq('track', 'PageView');
}

function loadTikTok() {
  if (tiktokLoaded || !TIKTOK_ID) return;
  tiktokLoaded = true;
  /* eslint-disable */
  !function (w, d, t) {
    w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || [];
    ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie', 'holdConsent', 'revokeConsent', 'grantConsent'];
    ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
    for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; };
    ttq.load = function (e, n) {
      var r = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r; ttq._t = ttq._t || {}; ttq._t[e] = +new Date(); ttq._o = ttq._o || {}; ttq._o[e] = n || {};
      var s = d.createElement('script'); s.type = 'text/javascript'; s.async = !0; s.src = r + '?sdkid=' + e + '&lib=' + t;
      var a = d.getElementsByTagName('script')[0]; a.parentNode.insertBefore(s, a);
    };
    ttq.load(TIKTOK_ID);
    ttq.page();
  }(window, document, 'ttq');
  /* eslint-enable */
}

export function loadAdPixels() {
  if (!granted()) return;
  loadMeta();
  loadTikTok();
}

// Called on consent withdrawal: stop sending and remove the pixels' first-party cookies.
export function stopAdPixels() {
  if (window.fbq) window.fbq('consent', 'revoke');
  if (window.ttq && window.ttq.revokeConsent) window.ttq.revokeConsent();
  document.cookie.split(';').forEach((cookie) => {
    const name = cookie.split('=')[0].trim();
    if (!/^(_fbp|_fbc|_ttp|_tt_enable_cookie)$/.test(name)) return;
    const domains = [null, window.location.hostname, `.${window.location.hostname.split('.').slice(-2).join('.')}`];
    domains.forEach((domain) => { document.cookie = `${name}=; Max-Age=0; path=/${domain ? `; domain=${domain}` : ''}; SameSite=Lax`; });
  });
}

// SPA route change. The Meta Pixel tracks history changes itself; TikTok needs a nudge.
export function adPageView() {
  if (!granted()) return;
  const fresh = !metaLoaded && !tiktokLoaded;
  loadAdPixels();
  if (!fresh && tiktokLoaded && window.ttq) window.ttq.page();
}

// Website funnel events mapped to standard events. Meta restricts custom events for
// health and wellness sites, so only standard names are used.
const META_MAP = { generate_lead: 'Lead', sign_up: 'CompleteRegistration', app_open_click: 'ViewContent', store_click: 'ViewContent', pricing_click: 'ViewContent' };
const TIKTOK_MAP = { generate_lead: 'SubmitForm', sign_up: 'CompleteRegistration', app_open_click: 'ClickButton', store_click: 'Download', pricing_click: 'ClickButton' };

export function adEvent(name, params = {}) {
  if (!granted()) return;
  loadAdPixels();
  const label = /^[a-z0-9_ -]{1,40}$/i.test(String(params.destination || params.placement || '')) ? String(params.destination || params.placement) : undefined;
  if (metaLoaded && window.fbq && META_MAP[name]) window.fbq('track', META_MAP[name], label ? { content_name: label } : {});
  if (tiktokLoaded && window.ttq && TIKTOK_MAP[name]) window.ttq.track(TIKTOK_MAP[name], label ? { content_name: label } : {});
}
